// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"GroupPhotos_sliderContainer__1tiic","mobileContainer":"GroupPhotos_mobileContainer__3727f","groupPhotoItem":"GroupPhotos_groupPhotoItem__2W0og"};